import * as React from 'preact/compat'
import Api from "../../api"
import { ClaimTypes } from '../../models/CommentClaim'
import Modal from '../Modal'
import type { CommentAuthorModel, CommentModel } from './CommentTypes'
import { captureFetchException, loadStylesheet } from '../../common/helpers'
import alertCss from '../../../css/sg-alert.pcss.json'
import buttonsCss from '../../../css/buttons.pcss.json'
import formCss from '../../../css/form.pcss.json'
import type { TargetedEvent } from 'preact/compat'
import { showToast } from '../toast'

interface ClaimFormProps {
  commentId: number | string,
  onClose: () => void,
  updateComment: (comment: CommentModel, user: CommentAuthorModel) => void,
}

export default class ClaimForm extends React.Component<ClaimFormProps> {

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
  }

  submitForm = (event: TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()
    this.props.onClose()
    const formData = new FormData(event.currentTarget)
    Api.post({ url: 'comments/claim', body: formData })
      .then(result => {
        showToast({
          type: result.status !== 1 ? 'error' : 'success',
          text: result.message,
        })

        if (result.status === 1) {
          this.props.updateComment(result.comment, result.user)
        }
      })
      .catch(e => {
        captureFetchException(e)
        showToast({
          type: 'warning',
          text: 'При отправке жалобы произошла непредвиденная ошибка',
        })
      })
  }

  handleCloseClick = (event: TargetedEvent<HTMLButtonElement>) => {
    event.preventDefault()
    this.props.onClose()
  }

  render() {
    const { commentId, onClose } = this.props

    if (!commentId) {
      return null
    }

    const ClaimOptions = [
      <option value='' key='empty' disabled selected>Причина жалобы</option>,
    ]

    for (let value in ClaimTypes) {
      ClaimOptions.push(
        <option value={value} key={value}>{ClaimTypes[value]}</option>
      )
    }

    return <Modal onClose={onClose} showClose>
      <form onSubmit={this.submitForm}>
        <p className={alertCss['message']}>Пожаловаться</p>
        <input type='hidden' name='id' value={commentId}/>
        <select className={formCss['input']} name='type' required>
          {ClaimOptions}
        </select>
        <div className={alertCss['buttons']}>
          <button type='button' onClick={this.handleCloseClick} className={buttonsCss['low-contrast']}>Отмена</button>
          <button type='submit' className={buttonsCss['primary']}>Пожаловаться</button>
        </div>
      </form>
    </Modal>
  }
}
